import { Skeleton } from "@/components/ui/skeleton";

/**
 * AdminRouteLoader - A skeleton loader shown while admin role is being verified.
 * Mimics the AdminLayout structure for a seamless first-load experience.
 */
export function AdminRouteLoader() {
  return (
    <div className="min-h-screen flex w-full bg-background">
      {/* Sidebar skeleton - hidden on mobile */}
      <aside className="hidden lg:flex w-64 bg-card border-r border-border flex-col h-screen">
        <div className="p-6 border-b border-border">
          <Skeleton className="h-6 w-32 mb-2" />
          <Skeleton className="h-3 w-40" />
        </div>
        <div className="flex-1 px-3 py-4 space-y-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-10 w-full rounded-lg" />
          ))}
        </div>
        <div className="p-4 border-t border-border space-y-2">
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
        </div>
      </aside>

      {/* Main content skeleton */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Top bar skeleton */}
        <header className="sticky top-0 z-30 border-b border-border bg-background/95 backdrop-blur-sm">
          <div className="flex items-center justify-between px-4 lg:px-8 h-16">
            <Skeleton className="h-8 w-8 lg:hidden" />
            <Skeleton className="h-4 w-32" />
          </div>
        </header>

        {/* Page content skeleton */}
        <main className="flex-1 p-4 lg:p-8 space-y-6">
          <div className="flex items-center justify-between">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-10 w-32" />
          </div>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-28 rounded-xl" />
            ))}
          </div>
          <Skeleton className="h-64 rounded-xl" />
        </main>
      </div>
    </div>
  );
}

export default AdminRouteLoader;
